import React from 'react';
import activeHtml from 'react-active-html';
import { Link } from 'react-router-dom';
import settings from 'front-settings';
import classnames from 'classnames';

import styles from '../cms.module.scss';

class Text extends React.Component {
  componentsMap = {
    a: props => {
      const dataSlug = props['data-slug'];
      const isInternal = !!dataSlug;
      if (isInternal) {
        return <Link {...props} to={dataSlug} />;
      }

      const isAbsInternal = props.href.startsWith(global.location.origin);
      if (isAbsInternal) {
        const hrefParser = document.createElement('a');
        hrefParser.href = props.href;
        return <Link {...props} to={hrefParser.pathname} />;
      }

      return <a {...props}>{props.children}</a>;
    },
    img: props => (
      <img
        {...props}
        className={classnames([
          styles.cms__image,
          styles[`image-${props.format}`],
        ])}
        src={`${settings.BASE_URL}${props['data-thumbnail-width-960']}`}
        alt={props.alt}
      />
    ),
  }

  shouldComponentUpdate (nextProps) {
    return this.props.value !== nextProps.value;
  }

  render () {
    const { value } = this.props;

    const nodes = activeHtml(value, this.componentsMap);
    return (
      <div className={styles['cms-rte']}>
        <div className={styles['cms-rte__body']}>
          {nodes}
        </div>
      </div>
    );
  }
}

export default Text;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/Text/index.js